import React from 'react';
import * as ImagePicker from 'expo-image-picker';
import { View  ,TouchableOpacity , StyleSheet } from 'react-native';
import {Text,  Avatar ,TextInput, Button , RadioButton, DefaultTheme,Snackbar,Appbar } from 'react-native-paper';

const theme = {
  ...DefaultTheme,
  roundness: 4,
  colors: {
    ...DefaultTheme.colors,
    primary: '#2ebbc4',
    accent: '#2ebbc4',
    text:'#3a3635'
 
  },
  fonts: {
    regular : {
      fontFamily: 'iransans',
      fontWeight: 'normal',
    },
    medium : {
      fontFamily: 'iransans',
      fontWeight: 'normal',
    },
  }
};



export default class App extends React.Component {

    state={
        image: global.image,
        firstname: global.fname,
        lastname: global.lname,
        gender:global.gender+1,
        toastVisible: false,
        inputError1:false,
        inputError2:false,
        buttonDisabled : false,
        connectionToast:false,
        picked : false
      };



  render() {
    let { image } = this.state;
    return (
        <>
        
      <Appbar.Header style={{height:50,backgroundColor:'white'}} >
        <Appbar.Action icon="menu" color='#3a3635' onPress={() => props.navigation.openDrawer()} />
        <Appbar.Content title='ویرایش مشخصات'/>
        <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
      </Appbar.Header>


        <View style={{ backgroundColor:'white' ,flex:1,justifyContent:'center',alignItems:'center'}}>
  
        <View style={{width:'100%'}}>
          <TouchableOpacity onPress={this._pickImage}>
  
            <Avatar.Image theme= {theme} size={60} source={{ uri: image.uri }} style={{marginLeft:'auto',marginRight:'auto'}} />
          
            <Text style={{ marginTop:8,marginLeft:'auto',marginRight:'auto',marginBottom:5, fontSize:12, color:'#5a5a5a'}}>انتخاب تصویر</Text>
          </TouchableOpacity>
  
          <TextInput
              style={styles.inputContainerStyle}
              label="نام"
              value={this.state.firstname}
              onChangeText={firstname => this.setState({ firstname })}
              theme= {theme}
              selectionColor='#c4fbff'
              error = {this.state.inputError1}
            />
            <TextInput
              style={styles.inputContainerStyle}
              label="نام خانوادگی"
              value={this.state.lastname}
              onChangeText={lastname => this.setState({ lastname })}
              theme= {theme}
              selectionColor='#c4fbff'
              error = {this.state.inputError2}
            />
  
         <View style={{marginBottom:10,marginTop:10}}>
          <RadioButton.Group
            value={this.state.gender}
            onValueChange={gender => {
              global.gender =  gender -1;
              console.log(global.gender);
              this.setState({ gender: gender })}}
            theme= {theme}
          >
            <View style={{flexDirection:'row', marginLeft:'auto', marginRight:'auto'}}>
            <View style={styles.row}>
              <Text style={{color:'#3a3635'}}>زن</Text>
              <RadioButton theme= {theme} value={2} />
            </View>
            <View style={styles.row}>
              <Text style={{color:'#3a3635'}}>مرد</Text>
              <RadioButton theme= {theme} value={1} />
            </View>
            </View>
          </RadioButton.Group>
          </View>
        
       
           <Button mode='contained' dark={true} style={styles.button} color='#2ebbc4' theme= {theme} disabled={this.state.buttonDisabled} loading={this.state.buttonDisabled}
             onPress={() =>{
             let isValid1 = this.state.firstname.length > 2;
             let isValid2= this.state.lastname.length > 2 ;

             let base64Image = !this.state.picked ? null : 'data:image/jpeg;base64,'+this.state.image.base64;

             if (isValid1){
               global.fname= this.state.firstname;
             } else {
               this.setState({inputError1:true})
             }

             if (isValid2){
              global.lname= this.state.lastname;
            } else {
              this.setState({inputError2:true})
            }

            if (!isValid2 || !isValid1) { this.setState({toastVisible:true})}

            if (isValid1 && isValid2) {
              this.setState({buttonDisabled : true});

              fetch('https://fitwayz.ir/api/users/update',
              { 
                method:'POST',
                withCredentials: true,
                 
                headers:{
                  Accept: 'application/json',
                  Authorization: 'Bearer ' + global.token,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  fname: global.fname,
                  lname :global.lname,
                  gender : global.gender,
                  image : base64Image ,
                })
              })
              .then(response => response.json()).then(responseJson => {
                console.log(responseJson);
                global.image.uri = responseJson.image.replace('http','https');
                this.setState({buttonDisabled : false});
                this.props.navigation.goBack();
              })
              .catch(error => {
                this.setState({buttonDisabled : false,connectionToast:true});
              });
            }
          
             }}
            contentStyle={{width:170,height:46}}>تایید</Button>  
        </View>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.toastVisible}
          onDismiss={() => this.setState({ toastVisible: false })}>
          لطفا مشخصات خود را صحیح وارد کنید
        </Snackbar>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>


        </View>
        </>
    );
  }

  _pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      base64: true,
      allowsEditing: true,
      aspect: [1, 1],
    });
    
    if (result.cancelled) {
      return;
    }
    this.setState({ image: result ,picked : true});
  };



}

const styles = StyleSheet.create({
    inputContainerStyle: {
      marginLeft: 'auto',
      marginRight:'auto',
      width: '65%',
      marginBottom:20,
      backgroundColor:'white',
    },
    button:{
      marginLeft:'auto',
      marginRight:'auto',
      borderRadius:23,
      marginTop:30,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 40,
    },
  });
  
